import AttentionPanelSkeleton from '@/components/ui/AttentionPanelSkeleton.tsx';
import { Card } from '@/components/ui/Card.tsx';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
} from '@/components/ui/InfoCard.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

/** Kafel wskaźnika: etykieta, duża liczba, pasek i dwa wiersze stopki. */
const MetricCardSkeleton = () => (
  <Card className="px-5 py-4">
    <Skeleton className="h-3 w-24" />
    <div className="mt-2.5 flex items-baseline gap-2">
      <Skeleton className="h-7 w-28" />
      <Skeleton className="h-4 w-20" />
      <Skeleton className="ml-auto h-4 w-10" />
    </div>
    <Skeleton className="mt-3 h-2 w-full rounded-full" />
    <div className="mt-3.5 flex flex-col gap-2 border-t border-neutral-100 pt-3">
      <div className="flex items-baseline justify-between gap-3">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-4 w-16" />
      </div>
      <div className="flex items-baseline justify-between gap-3">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  </Card>
);

/** Szkielet zakładki „Podsumowanie” — ten sam układ, co treść, którą zastąpi. */
const TourSummaryTabSkeleton = () => (
  <div className="flex flex-col gap-4">
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <MetricCardSkeleton />
      <MetricCardSkeleton />
    </div>

    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <AttentionPanelSkeleton rows={5} />

      <InfoCard>
        <InfoCardHeader title={<Skeleton className="h-3 w-28" />} />
        <InfoCardBody className="gap-4">
          <div>
            <Skeleton className="h-7 w-12" />
            <Skeleton className="mt-1.5 h-4 w-64" />
          </div>
          <Skeleton className="h-[220px] w-full" />
          <div className="flex flex-wrap gap-x-4 gap-y-1.5">
            <Skeleton className="h-3 w-36" />
            <Skeleton className="h-3 w-40" />
            <Skeleton className="h-3 w-44" />
          </div>
          <Skeleton className="h-8 w-full" />
        </InfoCardBody>
      </InfoCard>
    </div>
  </div>
);

export default TourSummaryTabSkeleton;
